export enum ViewerView {
  Coronal = 'Coronal',
  Model3D = '3D Model',
  Axial = 'Axial',
  Sagittal = 'Sagittal',
}

export interface IViewerViewOrder {
  name: ViewerView;
  order: number;
  id: number;
}
